import {useEffect} from 'react'

/**
 * Lock the body scrolling by applying styles to the body element. 
 * It will also save the current scroll position and restore it when unlocking.
 */

const useLockBodyScrolling = (isLocked: boolean) => {
  useEffect(() => {
    if (typeof document === 'undefined') return

    const lock = () => {
      const scrollY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop || 0
      document.body.dataset.scrollY = `${scrollY}`
      document.body.style.top = `-${scrollY}px`
      document.body.classList.add('no-body-scrolling')
    }

    const unlock = () => {
      const scrollY = document.body.dataset.scrollY
      document.body.classList.remove('no-body-scrolling')
      document.body.style.top = ''
      if (scrollY) {
        window.scrollTo(0, parseInt(scrollY, 10))
        delete document.body.dataset.scrollY
      }
    }

    if (isLocked) {
      lock()
    } else {
      unlock()
    }

    return () => {
      unlock()
    }
  }, [isLocked])
}

export default useLockBodyScrolling
